import React from 'react';

//components
import { CancelConfirmModal } from 'thrive-components';

//interfaces
import { IRemoveTermModal } from 'interfaces/languages';

//styles
import "../../../../css/modals/removeTermModal.scss";



const  RemoveTermModal = ({showModal, setRemoveTermItem, onConfirmClick}:IRemoveTermModal) => {    
    if (!showModal) { return <></> }
    return (
        <CancelConfirmModal 
            className='remove-term-modal'
            headerContent={
                <span className='remove-term-header'>
                    Remove term?
                </span>
            } 
            bodyContent={
                <span className='remove-term-explainer'>
                    Are you sure you want to remove this term? Existing translations will remain unchanged until the content is saved again or Quick Translate is run.
                </span>
            } 
            onCloseClick={setRemoveTermItem} 
            cancelButtonText={'Cancel'} 
            cancelButtonAriaLabel={'Cancel, and do not remove term.'} 
            confirmButtonText={'Remove'} 
            confirmButtonAriaLabel={'Remove term from non-translated term list'} 
            onCancelClick={setRemoveTermItem} 
            onConfirmClick={onConfirmClick}
        />        
    );
};

export default RemoveTermModal;